import { useMemo, useEffect, useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

function RightRuler() {
  const ticks = useMemo(() => Array.from({ length: 31 }, (_, i) => i * 5), []);
  const rulerRef = useRef(null);
  const y = useMotionValue(0);
  const smoothY = useSpring(y, { damping: 25, stiffness: 400 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (rulerRef.current) {
        const rect = rulerRef.current.getBoundingClientRect();
        const relativeY = e.clientY - rect.top;
        const pixels = Math.max(0, Math.min(390, relativeY));
        y.set(pixels);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [y]);

  return (
    <div ref={rulerRef} className="relative hidden lg:block pointer-events-none select-none">
      {/* Cursor-following Triangle marker */}
      <motion.div
        className="absolute -left-6 w-0 h-0 border-t-[10px] -mt-[10px] border-b-[10px] border-l-[10px] border-transparent border-l-white"
        style={{
          top: smoothY,
          transformTemplate: ({ top }) => `translateY(calc(${top}px - 50%))`
        }}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3, delay: 2.4, ease: "easeOut" }}
      />
      <div className="flex flex-col items-start gap-2 justify-center">
        <div className="relative flex flex-col items-start gap-3 justify-center">
          {/* Main border line */}
          <svg className="absolute top-0 left-0 w-px h-full">
            <motion.line
              x1="0"
              y1="0"
              x2="0"
              y2="100%"
              stroke="white"
              strokeWidth="1"
              vectorEffect="non-scaling-stroke"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 1.2, delay: 1.2, ease: "easeInOut" }}
            />
          </svg>
          {ticks.map((n, i) => (
            <div key={i} className="relative">
              <motion.div 
                className={`${i % 5 === 0 ? "w-4 h-px bg-white" : "w-2 h-px bg-white"}`}
                initial={{ scaleX: 0, opacity: 0 }}
                animate={{ scaleX: 1, opacity: 1 }}
                transition={{ 
                  duration: 0.2, 
                  delay: 2.4 + i * 0.02, 
                  ease: "easeOut" 
                }}
                style={{ transformOrigin: "left" }}
              />
              {i % 5 === 0 && (
                <motion.div 
                  className="absolute left-6 -mt-4 h-6 text-left text-white"
                  initial={{ opacity: 0, x: 5 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ 
                    duration: 0.3, 
                    delay: 2.4 + i * 0.02 + 0.1, 
                    ease: "easeOut" 
                  }}
                >
                  {n}
                </motion.div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RightRuler;